import type { MarkViewerComponent } from '@blissbook/lib/document/renderer/marks'

export const BoldMarkViewer: MarkViewerComponent = ({ mark, ...props }) => (
  <strong {...props} />
)
